export function EmailIcon({ className }: { className?: string }) {
    return (
      <svg 
        className={className} 
        width="36" 
        height="36" 
        viewBox="0 0 36 36" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path 
          d="M3.375 4.5C1.51172 4.5 0 6.01172 0 7.875C0 8.93672 0.499219 9.93516 1.35 10.575L16.65 22.05C17.4516 22.6477 18.5484 22.6477 19.35 22.05L34.65 10.575C35.5008 9.93516 36 8.93672 36 7.875C36 6.01172 34.4883 4.5 32.625 4.5H3.375ZM0 12.375V27C0 29.482 2.01797 31.5 4.5 31.5H31.5C33.982 31.5 36 29.482 36 27V12.375L20.7 23.85C19.0969 25.0523 16.9031 25.0523 15.3 23.85L0 12.375Z" 
          fill="#FFF134" 
        />
      </svg>
    )
  }